import { touchControl, airplaneState } from '../airplane/state.js';
import { startLaunchCharge, cancelLaunchCharge } from '../airplane/update.js';

// Helper to identify which zone a touch is in
function getTouchZone(touch) {
  const x = touch.clientX;
  const y = touch.clientY;
  const w = window.innerWidth;
  const h = window.innerHeight;
  
  // Left edge zones (throttle)
  if (x < 100) {
    if (y < h * 0.45) return 'throttleUp';
    if (y > h * 0.55) return 'throttleDown';
  }
  // Right edge zones (strafe)
  if (x > w - 100) {
    if (y < h * 0.45) return 'strafeLeft';
    if (y > h * 0.55) return 'strafeRight';
  }
  return null;
}

// Update touch zone visual state
function updateTouchZoneVisual(zone, active) {
  const zoneMap = {
    throttleUp: 'throttle-zone-up',
    throttleDown: 'throttle-zone-down',
    strafeLeft: 'strafe-zone-left',
    strafeRight: 'strafe-zone-right'
  };
  const el = document.getElementById(zoneMap[zone]);
  if (el) {
    el.classList.toggle('active', active);
  }
}

// Handle touch start on zones
function handleZoneTouchStart(e) {
  for (const touch of e.changedTouches) {
    const zone = getTouchZone(touch);
    if (zone) {
      touchControl.activeTouches.set(touch.identifier, zone);
      touchControl[zone] = true;
      updateTouchZoneVisual(zone, true);
      
      // Handle special flight state actions
      // Start launch charge when landed and throttle up is touched
      if (zone === 'throttleUp' && airplaneState.flightState === 'landed') {
        startLaunchCharge();
      }
    }
  }
}

// Handle touch move (finger might slide between zones)
function handleZoneTouchMove(e) {
  for (const touch of e.changedTouches) {
    const oldZone = touchControl.activeTouches.get(touch.identifier);
    const newZone = getTouchZone(touch);
    
    if (oldZone !== newZone) {
      // Left old zone
      if (oldZone) {
        touchControl[oldZone] = false;
        updateTouchZoneVisual(oldZone, false);
      }
      // Entered new zone
      if (newZone) {
        touchControl.activeTouches.set(touch.identifier, newZone);
        touchControl[newZone] = true;
        updateTouchZoneVisual(newZone, true);
      } else {
        touchControl.activeTouches.delete(touch.identifier);
      }
    }
  }
}

// Handle touch end on zones
function handleZoneTouchEnd(e) {
  for (const touch of e.changedTouches) {
    const zone = touchControl.activeTouches.get(touch.identifier);
    if (zone) {
      touchControl[zone] = false;
      touchControl.activeTouches.delete(touch.identifier);
      updateTouchZoneVisual(zone, false);
      // Cancel launch charge if throttleUp released
      if (zone === 'throttleUp' && airplaneState.launchCharging) {
        cancelLaunchCharge();
      }
    }
  }
}

export function setupTouchControls() {
  // Attach touch zone listeners
  document.addEventListener('touchstart', handleZoneTouchStart, { passive: true });
  document.addEventListener('touchmove', handleZoneTouchMove, { passive: true });
  document.addEventListener('touchend', handleZoneTouchEnd, { passive: true });
  document.addEventListener('touchcancel', handleZoneTouchEnd, { passive: true });
}
